import { Profile } from 'app/redux/Profile/model'
import * as _ from 'lodash'
import * as moment from 'moment'
import { WebServiceBase, WebServiceResponse } from '../WebServiceBase'

interface IPokeandPullRequest {
  [key: string]: IWorkbookValues | IRequestedValues | string
}

interface IRequestedValues {
  [key: string]: string[]
}

// tslint:disable-next-line:max-classes-per-file
interface ISheetValues {
  [key: string]: any
}

interface IWorkbookService {
  pokeAndPull(accessToken: string, requested: IPokeandPullRequest): Promise<WorkbookServiceResponse>
}

interface IWorkbookValues {
  [key: string]: ISheetValues
}

// tslint:disable-next-line:max-classes-per-file
class WorkbookServiceResponse extends WebServiceResponse {
  public static fromJSON(raw: any): WorkbookServiceResponse {
    const r = new WorkbookServiceResponse();
    return r.deserialize(raw);
  }

  public static isEqual(a: WorkbookServiceResponse, b: WorkbookServiceResponse): boolean {
    if (!a || !b) { return false }
    return _.isEqual(a, b)
  }

  Results: IWorkbookValues

  deserialize(raw: any): WorkbookServiceResponse {
    // tslint:disable:no-console
    //console.log('got raw response')
    super.deserialize(raw);
    //console.log('SSA raw looks like: ' + JSON.stringify(raw, undefined, 4))
    return this
  }
}

export {
  IPokeandPullRequest,
  IRequestedValues,
  ISheetValues,
  IWorkbookService,
  IWorkbookValues,
  WorkbookServiceResponse
}



// WEBPACK FOOTER //
// ./src/app/services/models/Workbook.ts